export default "__VITE_ASSET__BQVyN9id__"